import React, {PureComponent} from "react"

import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {User} from "@irati/types"
import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import Icon from "@irati/ui/src/Icon"
import RewardWalletBalanceQuery, {RewardWalletBalanceData} from "@irati/wallet/apollo/query/RewardWallet"
import TenantWalletTransferType from "@irati/wallet/enums/TenantWalletTransferType"
import {Wrapper, Row, StyledPara} from "./styled"

interface Props {
  recipient: User,
  amount: number,
  isFirst?: boolean,
  transferType: TenantWalletTransferType
}

class RewardWalletRow extends PureComponent<Props> {
  static defaultProps = {
    isFirst: false
  }
  returnRewardWalletBalanceVariables = (user: User) => ({
    currency: authentication.defaultUserCurrency(),
    tenantId: authentication.userTenant().uuid,
    userId: user.uuid
  })
  render() {
    const {recipient, isFirst, amount, transferType} = this.props
    const currency = authentication.defaultUserCurrency()
    const fullName = firstnameLastname(recipient)
    return (       
      <Wrapper isFirst={isFirst}>
        <RewardWalletBalanceQuery
          fetchPolicy="no-cache"
          variables={this.returnRewardWalletBalanceVariables(recipient)}>
          {({data: {rewardWallet}}: RewardWalletBalanceData) => {
            return (
            <>
              <Row>
                <StyledPara bold>
                  {transferType === TenantWalletTransferType.TRANSFER &&
                  <FormattedMessage 
                    values={{fullName}}
                    id="wallet.tenant.transferConfirmation.transferredTo" />
                  }
                  {transferType === TenantWalletTransferType.REFUND &&
                  <FormattedMessage 
                    values={{fullName}}
                    id="wallet.tenant.transferConfirmation.refundedFrom" />
                  }
                </StyledPara>
                <StyledPara bold>
                  <FormattedCurrency isCents={false} currency={currency} value={amount} />
                </StyledPara>
              </Row>
              <Row>
                <StyledPara light> 
                  <FormattedMessage id="wallet.tenant.transferConfirmation.rewardWallet" />
                  <Icon icon="wallet" /></StyledPara>
                <StyledPara light>
                  <FormattedCurrency isCents={false} currency={currency} value={rewardWallet.availableBalance} />
                </StyledPara>
              </Row>
            </>
            )
          }}
        </RewardWalletBalanceQuery>
      </Wrapper>
    )
  }
}

export default RewardWalletRow